module.exports = __webpack_public_path__ + "static/images/three-arrow.11UMqWK.svg";